import { jsx } from "react/jsx-runtime";
import { ColorGray200 } from "@nxt-costco-com/forge-design-tokens";
import { CATEGORY_ITEM_TYPE } from "../constants.js";
import { placementToCategoryTiles, placementItemToAdBuilder } from "../utils.js";
import { CardComposer } from "../../CardComposer/index.js";
import { CATEGORY_TILE, AD_BUILDER_COMPONENT } from "../../CardComposer/constants.js";
import { FourCornersCategoryTile } from "../../FourCornersCategoryTile/index.js";
const AdButlerAdTypesComposer = ({
  adData,
  itemType,
  externalLinkModule
}) => {
  if (itemType === CATEGORY_ITEM_TYPE) {
    const categoryAdData = adData;
    const componentData2 = placementToCategoryTiles(
      categoryAdData,
      adData == null ? void 0 : adData.redirect_url
    );
    if (!(componentData2 == null ? void 0 : componentData2.length)) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      FourCornersCategoryTile,
      {
        categoryTiles: componentData2.map((category, index) => /* @__PURE__ */ jsx(
          CardComposer,
          {
            componentType: CATEGORY_TILE,
            data: category,
            externalLinkModule
          },
          index
        )),
        titleProps: {
          title: categoryAdData.template_params.Title,
          titleAlignment: "center",
          titleBackgroundColor: ColorGray200
        },
        bodyBackgroundColor: void 0,
        ignoreBackground: false
      }
    );
  }
  const componentData = placementItemToAdBuilder(
    adData
  );
  return /* @__PURE__ */ jsx(
    CardComposer,
    {
      componentType: AD_BUILDER_COMPONENT,
      data: componentData,
      externalLinkModule
    }
  );
};
export {
  AdButlerAdTypesComposer
};
